import UserPage from "@/views/pef/PefDetailsPage"
import UsersPage from "@/views/admin/UsersPage"
import UserForm from "@/views/user/UserForm"
import FeedbackForm from "@/views/feedback/FeedbackForm"
import ProfilePage from "@/views/ProfilePage"
import RouteWrapper from "@/views/RouteWrapper"
import HomePage from "@/views/HomePage"
import TypesPage from "@/views/admin/TypesPage"
import InterventionForm from "@/views/intervention/InterventionForm"
import AoForm from "@/views/ao/AoForm"
import MentorTable from "@/views/diary/MentorTable"
import MentorDiaryForm from "@/views/diary/MentorDiaryForm"
import PefDiaryForm from "@/views/pef/PefDiaryForm"
import TrainingForm from "@/views/training/TrainingForm"
import MentorsPage from "@/views/diary/MentorsPage"
import PefListPage from "@/views/pef/PefListPage"
import AssignPefCoach from "@/views/admin/AssignPefCoach.vue";

export default [
  {
    path: "/",
    // Relative to /src/views
    name: "dashboard",
    redirect: "/home",
    menu: true,
    meta: {
      img: "/icons/home_page.png",
    },
    view: "RouteWrapper",
    children: [
      {
        path: "/home",
        name: "home",
        menu: false,
        component: HomePage,
      },
      {
        path: "/users/:user_id",
        name: "users",
        menu: false,
        component: UserPage,
      },
      {
        path: "/feedback/",
        name: "feedbacks",
        menu: false,
        component: RouteWrapper,
        redirect: "/users/:user_id",
        children: [
          {
            path: "/feedback/add/:user_id",
            name: "feedback_form",
            menu: false,
            component: FeedbackForm,
          },
          {
            path: "/feedback/edit/:feedback_id/:user_id",
            name: "feedback_form_edit",
            menu: false,
            component: FeedbackForm,
          },
        ],
      },
      {
        path: "/trainings/",
        name: "trainings",
        menu: false,
        component: RouteWrapper,
        redirect: "/users/:user_id",
        children: [
          {
            path: "/training/add/:user_id",
            name: "training_form",
            menu: false,
            component: TrainingForm,
          },
          {
            path: "/training/edit/:training_id/:user_id",
            name: "training_form_edit",
            menu: false,
            component: TrainingForm,
          },
        ],
      },
      {
        path: "/intervention/",
        name: "interventions",
        menu: false,
        component: RouteWrapper,
        redirect: "/users/:user_id",
        children: [
          {
            path: "/intervention/add/:user_id",
            name: "intervention_form",
            menu: false,
            component: InterventionForm,
          },
          {
            path: "/intervention/edit/:intervention_id/:user_id",
            name: "intervention_form_edit",
            menu: false,
            component: InterventionForm,
          },
        ],
      },
      {
        path: "/ao/",
        name: "ao",
        menu: false,
        component: RouteWrapper,
        redirect: "/users/:user_id",
        children: [
          {
            path: "/ao/add/:user_id",
            name: "ao_form",
            menu: false,
            component: AoForm,
          },
          {
            path: "/ao/edit/:ao_id/:user_id",
            name: "ao_form_edit",
            menu: false,
            component: AoForm,
          },
        ],
      },
      {
        path: "/profile",
        name: "profile",
        menu: false,
        component: ProfilePage,
        meta: {
          icon: "mdi-user",
        },
      },
    ],
  },
  {
    path: "/diary_mentor/",
    name: "mentor_diary_home",
    menu: true,
    component: MentorTable,
    view: "RouteWrapper",
    meta: {
      img: "/icons/journal.png",
      restricted: ["MENTOR"],
    },
    redirect: "/diary_mentor",
    children: [
      {
        path: "/diary_mentor",
        name: "mentor_diary",
        meta: {
          icon: "mdi-newspaper",
        },
        menu: false,
        component: MentorTable,
      },
      {
        path: "/diary_mentor/:user_id",
        name: "mentor_diary_user",
        meta: {
          icon: "mdi-newspaper",
        },
        menu: false,
        component: MentorTable,
      },
      {
        path: "/diary_mentor/add/:user_id",
        name: "mentor_diary_add",
        menu: false,
        component: MentorDiaryForm,
      },
      {
        path: "/diary_mentor/edit/:diary_id/:user_id",
        name: "diary_mentor_form_edit",
        menu: false,
        component: MentorDiaryForm,
      },
    ],
  },
  {
    path: "/diary_mentors/",
    name: "mentors",
    menu: true,
    component: MentorsPage,
    view: "RouteWrapper",
    meta: {
      icon: "mdi-newspaper",
      restricted: ["ADMIN", "SUPERADMIN"],
    },
    children: [
      {
        path: "/diary_mentors",
        name: "mentors_diary",
        meta: {
          icon: "mdi-newspaper",
        },
        menu: false,
        component: MentorsPage,
      },
    ],
  },
  {
    path: "/pef_list/",
    name: "pef_list",
    menu: true,
    component: PefListPage,
    view: "RouteWrapper",
    meta: {
      img: "/icons/PEF.png",
      restricted: ["COACH", "CHIEF", "MENTOR", "ADMIN", "SUPERADMIN"],
    },
    redirect: "/pef_list",
    children: [
      {
        path: "/pef_list",
        name: "pef_diary",
        meta: {},
        menu: false,
        component: PefListPage,
      },
    ],
  },
  {
    path: "/diary_pef/",
    name: "diary_pef",
    menu: false,
    component: PefListPage,
    view: "RouteWrapper",
    meta: {
      img: "/icons/journal_PEF.png",
      restricted: ["PEF", "MENTOR", "ADMIN", "SUPERADMIN"],
    },
    redirect: "/diary_list_pef",
    children: [
      {
        path: "/diary_pef/add/:user_id",
        name: "pef_diary_add",
        menu: false,
        component: PefDiaryForm,
      },
      {
        path: "/diary_pef/edit/:diary_id/:user_id",
        name: "pef_diary_form_edit",
        menu: false,
        component: PefDiaryForm,
      },
    ],
  },
  {
    path: "/admin",
    name: "admin",
    menu: true,
    meta: {
      img: "/icons/settings.png",
      restricted: ["MENTOR", "ADMIN", "SUPERADMIN"],
    },
    view: "RouteWrapper",
    redirect: "/admin/users",

    children: [
      {
        path: "/admin/users",
        name: "admin_users",
        menu: true,
        meta: {
          img: "/icons/utilisateurs.png",
        },
        component: UsersPage,
      },
      {
        path: "/admin/assign_pef_coach",
        name: "assign_pef_coach",
        menu: true,
        meta: {
          img: "/icons/assignment.png",
        },
        component: AssignPefCoach,
      },
      {
        path: "/admin/users/add",
        name: "admin_users_form",
        menu: false,
        component: UserForm,
      },
      {
        path: "/admin/users/edit/:user_id",
        name: "admin_users_form_edit",
        menu: false,
        component: UserForm,
      },
      {
        path: "/admin/type",
        name: "admin_types",
        menu: true,
        meta: {
          icon: "mdi-database",
        },
        component: TypesPage,
      },
    ],
  },

  {
    path: "/404",
    name: "404",
    menu: false,
    meta: {
      title: "Not Found",
    },
    component: () => import("@/views/error/NotFound.vue"),
  },

  {
    path: "/500",
    name: "500",
    menu: false,
    meta: {
      title: "Server Error",
    },
    component: () => import("@/views/error/Error.vue"),
  },
]
